<div class="arrow-bottom relative mb-11 min-h-80 w-full">
    <div class="flex min-h-80 flex-col items-center justify-center px-4 py-5 sm:px-8 xl:py-14 2xl:py-20">
        @if (headerBlock().image) {
            <img
                width="255"
                height="160"
                class="max-h-25 min-h-25 max-w-32 min-w-32 object-contain lg:max-w-40 lg:min-w-40 xl:max-w-48 xl:min-w-48 2xl:max-w-63.5 2xl:min-w-63.5"
                [ngSrc]="headerBlock().image | getDirectusImage"
                [alt]="headerBlock().translations_refs | getTranslation: 'title'"
            />
        }

        <h1 class="xl:text-display-large text-display-small mb-0 text-center break-words text-white 2xl:mb-5">
            {{ headerBlock().translations_refs | getTranslation: "title" }}
        </h1>
        <p
            class="xl:text-title-small text-body-medium w-full text-center break-words text-white lg:max-w-130 2xl:max-w-full"
        >
            {{ headerBlock().translations_refs | getTranslation: "subtitle" }}
        </p>
    </div>
</div>
